"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _of = require("rxjs/observable/of");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _default = function _default(_ref) {
  var domainSelector = _ref.domainSelector,
      stageForEdit = _ref.stageForEdit;
  return function ($action, _ref2) {
    var getState = _ref2.getState;
    return $action.ofType(_ActionTypes.default.RESET_ALL_CHANGES).pipe((0, _map.map)(function () {
      return domainSelector(getState());
    }), (0, _mergeMap.mergeMap)(function (object) {
      return (0, _of.of)(stageForEdit(object));
    }));
  };
};

exports.default = _default;
module.exports = exports.default;